<template>
  <div class="page-title">{{ $t("location_page_title") }}</div>
  <div class="intro">{{ $t("location_subtitle") }}</div>

  <el-row :gutter="32">
    <el-col :lg="12" :md="24">
      <div class="table-header">
        <HeadingTitle>
          <template #svg>
            <el-image
              class="menu-logo white no-select"
              :src="require('@/img/house-white.svg')"
            />
          </template>
        </HeadingTitle>
        <div class="title">{{ $t("added_location_groups") }}</div>
      </div>
      <div class="table-container">
        <vue-collapsible-panel-group accordion>
          <vue-collapsible-panel
            :name="vg.idvirtualgroup"
            v-for="vg in virtualgroups"
            :key="vg.idvirtualgroup"
          >
            <template #title>
              {{ vg.name }}
            </template>
            <template #actions>
              <Edit @click="editGroup(vg.idvirtualgroup)" />
              <el-popconfirm
                :confirmButtonText="$t('yes')"
                :cancelButtonText="$t('no')"
                :title="$t('delete_group_confirm')"
                @confirm="deleteGroup(vg.idvirtualgroup)"
              >
                <template #reference>
                  <Delete />
                </template>
              </el-popconfirm>
            </template>
            <template #content>
              <div class="assigned-cities">{{ $t("assigned_locations") }}</div>
              <div
                class="no-cities"
                v-if="!virtualgroups_mapping[vg.idvirtualgroup]"
              >
                {{ $t("no_assigned_locations") }}
              </div>
              <ul
                class="cities"
                v-if="virtualgroups_mapping[vg.idvirtualgroup]"
              >
                <li
                  v-for="location_id in virtualgroups_mapping[vg.idvirtualgroup]
                    .idlocations"
                  :key="location_id"
                >
                  <div>
                    {{
                      locations[0].find(i => i.idlocation == location_id).name
                    }}
                  </div>
                </li>
              </ul>
            </template>
          </vue-collapsible-panel>
        </vue-collapsible-panel-group>
      </div>
    </el-col>
    <el-col :lg="12" :md="24">
      <div class="table-header">
        <HeadingTitle>
          <template #svg>
            <el-image
              class="menu-logo white no-select"
              :src="require('@/img/house-white.svg')"
            />
          </template>
        </HeadingTitle>
        <div class="title" v-if="!edit">{{ $t("add_locations_group") }}</div>
        <div class="title" v-if="edit">{{ $t("edit_locations_group") }}</div>
      </div>
      <div class="table-container">
        <el-form
          label-width="0"
          status-icon
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
        >
          <el-row :gutter="24">
            <el-col :span="24">
              <div class="subtitle">{{ $t("enter_data") }}</div>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="name">
                <el-input
                  :placeholder="$t('group_name')"
                  v-model="ruleForm.name"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="email">
                <MultiSelect
                  v-model="new_group_cities"
                  :options="locations[0]"
                  :filter="true"
                  optionValue="idlocation"
                  optionLabel="name"
                  :placeholder="$t('locations_for_group')"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item>
            <el-button round @click="submitForm('ruleForm')" v-if="!edit">{{
              $t("add_group")
            }}</el-button>
            <el-button type="danger" round @click="cancelEdit()" v-if="edit">{{
              $t("cancel")
            }}</el-button>
            <el-button round @click="editGroupSave('ruleForm')" v-if="edit">{{
              $t("save")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-col>
  </el-row>
</template>

<style lang="scss" scoped>
.el-collapse {
  margin-bottom: 24px;

  ::v-deep(.el-collapse-item__wrap) {
    background-color: transparent !important;
    padding-top: 12px;
  }

  ::v-deep(.el-collapse-item__header) {
    background-color: #e6e6e6 !important;
    padding: 0 12px;
  }
}

.table-header {
  background-color: $gkt-orange-rgba;
  padding: 24px;
  border-top-left-radius: 21px;
  border-top-right-radius: 21px;
  display: flex;
  align-items: center;
  padding-bottom: 72px;

  .title {
    font-size: 21px;
    font-weight: 500;
    color: $gkt-white;
  }

  .el-image {
    line-height: 34px;
  }
}

.actions {
  position: relative;
  display: flex;
  align-self: center;
  justify-content: flex-end;
  flex: 1;
  z-index: 666;

  .small-rounded-btn.toggle-up {
    display: none;
  }
}

.subtitle {
  font-size: 15px;
  color: $gkt-orange-rgba;
  margin-bottom: 12px;
}

.table-container {
  padding: 24px 48px;
  background-color: $gkt-light-grey;
  border-radius: 21px;

  position: relative;
  top: -48px;

  .assigned-cities {
    font-size: 15px;
    font-weight: 500;
    color: $gkt-orange;
  }

  .no-cities {
    margin-top: 12px;
    color: darken($gkt-light-grey, 10);
  }

  .cities {
    margin: 0;
    padding: 0;
    margin-top: 12px;
    list-style: none;
    display: flex;
    flex-wrap: wrap;

    li {
      background-color: #efefef;
      padding: 4px 12px;
      margin-right: 4px;
      margin-bottom: 4px;
      font-size: 14px;
      border-radius: 12px;
    }
  }
}

.p-multiselect {
  width: 100%;
  border-radius: 35px;
  padding-left: 24px;
  height: 44px;

  :deep(.p-multiselect-label) {
    padding: 0;
  }
}
</style>

<script>
import { provide } from "vue";
import store from "@/store";
import { Delete, Edit, HeadingTitle } from "@/components/buttons";
import VueCollapsiblePanelGroup from "@/components/collapsible/VueCollapsiblePanelGroup.vue";
import VueCollapsiblePanel from "@/components/collapsible/VueCollapsiblePanel.vue";
import MultiSelect from "primevue/multiselect";

export default {
  name: "location",
  setup() {
    provide("store", store);
  },
  components: {
    Delete,
    HeadingTitle,
    Edit,
    VueCollapsiblePanelGroup,
    VueCollapsiblePanel,
    MultiSelect
  },
  data() {
    var validateName = (rule, value, callback) => {
      if (!value.length) {
        callback(new Error(this.$t("enter_group_name")));
      } else if (
        this.virtualgroups.find(function(group) {
          return group.name == value;
        })
      ) {
        if (this.edit && this.edit.name == value) {
          this.$refs.ruleForm.validateField("name");
          callback();
        } else {
          callback(new Error(this.$t("duplicate_group_name")));
        }
      } else {
        if (this.ruleForm.name.length > 0 && this.multiplelocation) {
          this.$refs.ruleForm.validateField("name");
        }
        callback();
      }
    };

    return {
      ruleForm: {
        name: []
      },
      rules: {
        name: [{ validator: validateName, trigger: "blur" }]
      },
      virtualgroups: [],
      locations: [],
      virtualgroups_mapping: [],
      new_group_cities: [],
      edit: null
    };
  },
  methods: {
    async deleteGroup(id) {
      const response = await store.methods.apiRequest("removeVirtualGroup", {
        idvirtualgroup: id
      });

      const res = response.data;

      if (res.status == "success") {
        this.$message({
          showClose: true,
          message: this.$t("locations_group_deleted"),
          type: "success",
          offset: 350
        });

        this.getVirtualGroups();
      } else {
        this.$message({
          showClose: true,
          message: res.errordetails,
          type: "error",
          offset: 350
        });
      }
    },
    editGroup(id) {
      const group = this.virtualgroups.find(it => it.idvirtualgroup == id);

      if (group) {
        this.edit = group;
        this.ruleForm.name = group.name;
        const chosenCities = [];

        if (this.virtualgroups_mapping[id]) {
          for (const i in this.virtualgroups_mapping[id].idlocations) {
            chosenCities.push(parseInt(i));
          }
        }

        this.new_group_cities = chosenCities;
      }
    },
    editGroupSave(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const response = await store.methods.apiRequest(
            "changeVirtualGroupName",
            {
              name: this.ruleForm.name,
              idvirtualgroup: this.edit.idvirtualgroup
            }
          );

          const res = response.data;
          const cities = this.new_group_cities;

          if (res.status == "success") {
            await store.methods.apiRequest("setVGroupLocations", {
              idvirtualgroup: this.edit.idvirtualgroup,
              locations: cities
            });

            this.$message({
              showClose: true,
              message: this.$t("locations_group_changed"),
              type: "success",
              offset: 350
            });

            this.clearData();
            this.getVirtualGroups();
          } else {
            this.$message({
              showClose: true,
              message: res.errordetails,
              type: "error",
              offset: 350
            });
          }
        } else {
          return false;
        }
      });
    },
    cancelEdit() {
      this.edit = null;
      this.clearData();
    },
    clearData() {
      this.ruleForm.name = "";
      this.new_group_cities = [];
      this.edit = null;
    },
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const response = await store.methods.apiRequest("addVirtualGroup", {
            name: this.ruleForm.name
          });

          const res = response.data;
          const cities = this.new_group_cities;

          if (res.status == "success") {
            if (cities.length > 0) {
              await store.methods.apiRequest("setVGroupLocations", {
                idvirtualgroup: res.results.idvirtualgroup,
                locations: cities
              });
            }

            this.$message({
              showClose: true,
              message: this.$t("locations_group_added"),
              type: "success",
              offset: 350
            });

            this.clearData();
            this.getVirtualGroups();
          } else {
            this.$message({
              showClose: true,
              message: res.errordetails,
              type: "error",
              offset: 350
            });
          }
        } else {
          return false;
        }
      });
    },
    async getVirtualGroups() {
      const response = await store.methods.apiRequest("getDataVirtualGroup");
      const res = response.data;

      console.log(res);

      if (res.errordetails) {
        console.log("error", res.errordetails);
      }

      if (res.results && res.results.virtualgroups) {
        this.virtualgroups = res.results.virtualgroups;
      }

      if (res.results && res.results.virtualgroups_mapping) {
        this.virtualgroups_mapping = res.results.virtualgroups_mapping;
      }

      if (res.results && res.results.locations) {
        this.locations = res.results.locations;
      }
    }
  },
  async mounted() {
    this.getVirtualGroups();
  }
};
</script>
